import { Route, Routes } from 'react-router-dom'
import Category from '../../components/category/category.component'

import CategoriesPreview from '../categories-preview/categories-preview'

const Shop = () => {
  return (
    <Routes>
      <Route index element={<CategoriesPreview />}></Route>
      <Route path=":category" element={<Category />} />
    </Routes>
  )
}

export default Shop
